import React from 'react';
import toast, { Toaster, ToastBar } from 'react-hot-toast';

const ToasterComponent = () => {
  const styles = {
    warning: {
      color: '#856404',
      backgroundColor: '#fff3cd',
    },
    success: {
      color: '#155724',
      backgroundColor: '#d4edda',
    },
    error: {
      color: '#721c24',
      backgroundColor: '#f8d7da',
    },
  };

  return (
    <Toaster
      position="top-center"
      toastOptions={{ duration: 5000 }}>
      {(t) => {
        const { type } = t;

        return (
          <ToastBar toast={t} style={styles[type]}>
            {({ message }) => (
              <>
                {message}
                {type !== 'loading' && (
                  <button
                    type="button"
                    className="close"
                    onClick={() => toast.dismiss(t.id)}>
                    <span aria-hidden="true">&times;</span>
                    <span className="sr-only">Close</span>
                  </button>
                )}
              </>
            )}
          </ToastBar>
        );
      }}
    </Toaster>
  );
};

export default ToasterComponent;
